import client from '../http_client';
import { parseItem, parseList } from './parsing';
import { CreateRequest, CreateKeyResponse, ListResponse } from './types';

const root = '/v1/api-keys';

export class ApiKeysService {
  public static async list(): Promise<ListResponse> {
    const response = await client.get<ListResponse>(root, {
      transformResponse: parseList,
    });
    return response.data;
  }

  public static async create(data: CreateRequest): Promise<CreateKeyResponse> {
    const response = await client.post<CreateKeyResponse>(root, data, {
      transformResponse: parseItem,
    });
    return response.data;
  }

  public static async delete(id: string): Promise<void> {
    await client.delete<void>(`${root}/${id}`);
  }
}
